(function() {
'use strict';

angular
    .module('searchUnit')
    .directive('parkingSearchUnit', parkingSearchUnit);

function parkingSearchUnit(searchUnitService, sharedSearchUnitService, occupancyService) {
    // Configuration part, mandatory in every searchunit directive with delayed linker
    sharedSearchUnitService.addDelayedLinker(_delayedLinker, 'parkingSearchUnit');

    return {
        restrict: 'E',
        replace: true,
        scope: {
            areaOverride: '@'
        },
        templateUrl: 'partials/searchunit/parking',
        controller: 'SharedSearchUnit',
        link(scope, el, attr, controller) {
            return sharedSearchUnitService.initializeArea(scope, el, attr, controller, 'parkingSearchUnit');
        }
    };

    function _delayedLinker(scope, el, attr, ssu) {
        const currentArea = sharedSearchUnitService.getAreaInfo(scope.areaOverride);
        const mode = currentArea.mode;
        const minPassengers = 1;
        const maxPassengers = occupancyService.adultRange(currentArea.name).max || 7;

        // Props on scope
        scope.passengerRange = _.range(minPassengers, maxPassengers + 1);

        // Methods on scope
        scope.departureAirportSelect = searchUnitService.setDepartureAirports;
        scope.departureAirportDeselect = departureAirportDeselect;
        scope.passengerSelect = passengerSelect;
        scope.search = search;

        // Initialise form
        _restoreSearchCriteria();


        function _restoreSearchCriteria() {
            scope.passengerCount = occupancyService.getPassengerCount() || 1;
            scope.departureAirport = searchUnitService.getSelectedDepartureAirport();
            scope.startDate = searchUnitService.startDate(mode);
            scope.endDate = searchUnitService.endDate(mode);
            passengerSelect();
        }

        function departureAirportDeselect() {
            return searchUnitService.clearDepartureAirports();
        }

        function passengerSelect() {
            occupancyService.setPassengerCount(scope.passengerCount);
        }

        function search() {
            ssu.lockScreen('SEARCHINGPARKING');
            sharedSearchUnitService.search(undefined, ssu.showErrors);
        }
    }
}
})();
